import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, Card, CardContent, Radio, List, ListItem, ListItemText, Button, Avatar, TextField, InputAdornment, IconButton, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getMlmuserInfoByUseridAPI, updateMlmuserInfo } from 'components/mlmuser/MlmuserAPI';
import EditIcon from '@mui/icons-material/Edit';
import { setselectedPkgObj } from 'store/slice/EcomSlice';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { initPartnershipAPI, initPartnerPaymentAPI, applyCouponAPI, removeCouponAPI, confirmPartnerPaymentAPI, updateAddressAPI } from 'api/CoreMlmmgmtWebServices';
import { setMlmUserObj } from 'store/slice/EcomSlice';
import { setuserprofileInfo } from 'store/slice/HeaderSlice';
import { convertToRS } from 'core/js/FormUtils';
import { setPaymentObj } from 'store/slice/EcomSlice';
import { setPartnershipInitiationMode, setInviteeObj } from 'store/slice/EcomSlice';
import { setMlmuserInitPartnershipModal, setSelectedProductId,updateMlmuserObj } from 'store/slice/DmpSlice';
import Confirmation from './Confirmation';

export default function PrePaymentReview({ setStage, onClose }) {
    const dispatch = useDispatch();
    const { userprofileInfo } = useSelector((state) => state.headerslice);
    const { selectedPkgObj, mlmUserObj, inviteeObj } = useSelector((state) => state.ecomslice.mlm);
    const [couponCode, setCouponCode] = useState('');
    const [couponError, setCouponError] = useState('');
    const [key, setKey] = useState(null);
    const { paymentObj } = useSelector((state) => state.ecomslice.checkout);
    const [paymentError, setPaymentError] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const { productObj } = useSelector((state) => state.dmpslice.productDashboard);

    // Address popup state
    const [addressDialogOpen, setAddressDialogOpen] = useState(false);
    const [addressForm, setAddressForm] = useState({
        address: '',
        city: '',
        pincode: ''
    });
    const [addressError, setAddressError] = useState('');
    const [addressApiInProgress, setAddressApiInProgress] = useState(false);

    useEffect(() => {
        if (selectedPkgObj && userprofileInfo && userprofileInfo.email != 'customer.dmp.01@gmail.com') {
            initPartnershipAPI({
                "pkgId": productObj.id
            }, initPartnershipAPISuccess, initPartnershipAPIFailure
            )
        }
    }, []);

    useEffect(() => {
        if (mlmUserObj && mlmUserObj.mlmusertypename==='PARTNER'){
            setStage('CONFIRMED');
        }
    }, [inviteeObj, mlmUserObj]);

    useEffect(() => {
        if (paymentObj && paymentObj.razorpay_payment_id) {
            setApiInProgress(true);
            confirmPartnerPaymentAPI(
                {
                    "paymentId": paymentObj.razorpay_payment_id,
                    "signature": paymentObj.razorpay_signature
                },
                (apiResponse) => {
                    if (apiResponse.success) {
                        setApiInProgress(false);
                        setStage('CONFIRMED');
                        dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
                        if (apiResponse.userProfileInfo) {
                            dispatch(setuserprofileInfo(apiResponse.userProfileInfo));
                        }
                    } else {
                        alert("Payment failed: " + apiResponse.message);
                    }
                },
                (errMsg) => {
                    setApiInProgress(false);
                    alert("Error in confirming payment: " + errMsg);
                }
            );
        }

    }, [paymentObj]);
    // useEffect(() => {
    //     if (key && mlmUserObj && mlmUserObj.paymentorderid) {
    //         initiateRazorPay(key, mlmUserObj.paymentorderid);
    //     }
    // },[key]);

    useEffect(() => {
        // console.log("mlmUserObj=>", JSON.stringify(mlmUserObj));
        // if (mlmUserObj && mlmUserObj.seniorpartnerid && mlmUserObj.seniorpartnerid !== 0) {
        //     getMlmuserInfoByUseridAPI(mlmUserObj.seniorpartnerid, () => { }, getMlmuserInfoByUseridAPISuccess)
        // }
    }, [mlmUserObj]);

    const initPartnershipAPISuccess = (apiResponse) => {
        console.log("initPartnershipAPI response=>", JSON.stringify(apiResponse));
        dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
        if (apiResponse.userprofileInfo) {
            dispatch(setuserprofileInfo(apiResponse.userprofileInfo));
        }
    }
    const initPartnershipAPIFailure = (errMsg) => {
        alert("Error in initPartnershipAPI: " + errMsg);
    }
    const initiateRazorPay = (key, paymentOrderId) => {
        var options = {
            "key": key, // Enter the Key ID generated from the Dashboard
            "amount": "100", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "G&R", //your business name
            "description": "Payment for Partnership",
            "image": "https://gnronline.in/gnr-logo.webp",
            "order_id": paymentOrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": function (response) {
                dispatch(setPaymentObj({
                    "razorpay_payment_id": response.razorpay_payment_id,
                    "razorpay_order_id": response.razorpay_order_id,
                    "razorpay_signature": response.razorpay_signature
                }))
                // alert(response.razorpay_payment_id);
                // alert(response.razorpay_order_id);
                // alert(response.razorpay_signature)
            },
            "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                "name": mlmUserObj.title, //your customer's name
                "email": mlmUserObj.mobilenumber,
                "contact": mlmUserObj.mobilenumber  //Provide the customer's phone number for better conversion rates 
            },
            "notes": {
                "address": mlmUserObj.address + ", " + mlmUserObj.city + " - " + mlmUserObj.pincode
            },
            "theme": {
                "color": "#3399cc"
            }
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.on('payment.failed', function (response) {
            console.log("Payment Failed ==>" + JSON.stringify(response));
            setPaymentError("Payment failed, please retry !!! " + response.error.description);
            //   alert(response.error.code);
            //   alert(response.error.description);
            //   alert(response.error.source);
            //   alert(response.error.step);
            //   alert(response.error.reason);
            //   alert(response.error.metadata.order_id);
            //   alert(response.error.metadata.payment_id);
        });
        rzp1.open();
    }
    const initiPaymentFailure = (err) => {
        alert("ERRROR ==>3" + err);
    }


    const getMlmuserInfoByUseridAPISuccess = (apiResponse) => {
        dispatch(setInviteeObj(apiResponse[0]));
    }
    const initiEditPkg = () => {
        setStage('SELECT_PACKAGE');
        dispatch(setSelectedProductId(-1))
        dispatch(setselectedPkgObj(null));
    }
    const handleApplyCoupon = (couponCode) => {
        if (!couponCode) {
            setCouponError("Please enter a coupon code");
            return;
        }
        applyCouponAPI(
            { "coupon": couponCode }
            ,
            (apiResponse) => {
                if (apiResponse.success) {
                    //setAppliedCoupon(couponCode);
                    dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
                    
                    setCouponError(''); // clear error on success
                } else {
                    setCouponError("Failed to apply coupon: " + apiResponse.message);
                }
            },
            (errMsg) => {
                setCouponError(errMsg);
            }
        );
    }
    const handleRemoveCoupon = () => {
        removeCouponAPI(
            {},
            (apiResponse) => {
                if (apiResponse.success) {
                    dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
                    setCouponCode(''); // clear coupon code
                    setCouponError(''); // clear error
                } else {
                    setCouponError("Failed to remove coupon: " + apiResponse.message);
                }
            },
            (errMsg) => {
                setCouponError(errMsg);
            }
        );
    }
    const handlePayAPIsuccess = (apiResponse) => {
         setApiInProgress(false);
        if (apiResponse.success) {
            setKey(apiResponse.key);
            dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
            if (apiResponse.key && apiResponse.mlmuserInfo) {
                initiateRazorPay(apiResponse.key, apiResponse.mlmuserInfo.paymentorderid);
            }

            // Optionally, you can redirect to a success page or show a success message
        } else {
            alert("Payment failed: " + apiResponse.message);
        }
    }
    const handlePayAPIfailure = (errMsg) => {
         setApiInProgress(false);
        alert("Error in payment: " + errMsg);
    }
    const handlePay = () => {
        setPaymentError(''); // clear previous error
        setApiInProgress(true);
        initPartnerPaymentAPI(
            {}, handlePayAPIsuccess, handlePayAPIfailure
        )
    }
    const handlePayment = () => {
        if (isDeliveryAddressComplete()) {
            if (mlmUserObj.paymentamount !== 0) {
                handlePay();
            }
            else {
                // Trigger payment confirmation API wihtout Razorpay

                dispatch(setPaymentObj({
                    "razorpay_payment_id": 'NA',
                    "razorpay_order_id": 'NA',
                    "razorpay_signature": 'NA'
                }));
            }
        } else {
            handleEditAddress();
        }
    }
    const handleClose = () => {
        dispatch(setPartnershipInitiationMode(false));
        dispatch(setMlmuserInitPartnershipModal(true));

    }

    const handleEditAddress = () => {
        setAddressForm({
                address: mlmUserObj.address || '',
                city: mlmUserObj.city || '',
                pincode: mlmUserObj.pincode || ''
            });
        setAddressDialogOpen(true);
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setAddressForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSaveAddress = () => {
        console.log("addressForm=>", JSON.stringify(addressForm));

        if (!addressForm.address.trim() || !addressForm.city.trim() || addressForm.pincode === '') {
            setAddressError('All fields are required.');
            return;
        }
        setAddressError('');
        setAddressApiInProgress(true);
        updateAddressAPI(
            {
                address: addressForm.address,
                city: addressForm.city,
                pincode: addressForm.pincode,
                userId: mlmUserObj.id
            },
            (apiResponse) => {
                console.log("updateAddressAPI response=>", JSON.stringify(apiResponse.mlmuserInfo));
                setAddressApiInProgress(false);
                dispatch(updateMlmuserObj(apiResponse.mlmuserInfo));
                dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
                setAddressDialogOpen(false);
                
            },
            (errMsg) => {
                setAddressApiInProgress(false);
                setAddressError(errMsg || 'Failed to update address');
            }
        );
    };

    const getAddress = () => {
        let address = '';
        address += mlmUserObj.address ? mlmUserObj.address : '';
        address += mlmUserObj.city ? ', ' + mlmUserObj.city : '';
        address += mlmUserObj.pincode ? ' - ' + mlmUserObj.pincode : '';
        return address;

    }
    const isDeliveryAddressComplete = () => { 
        if (mlmUserObj.address && mlmUserObj.city && mlmUserObj.pincode) return true;
        return false;
    }

    // Add this check at the top of your return
    if (mlmUserObj && mlmUserObj.partnershipstatus === 'CONFIRMED') {
        return (
            // <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, p: 3 }}>
            //     <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
            //     <Typography variant="h4" color="success.main" sx={{ fontWeight: 700, mb: 1 }}>
            //         You are already our partner!
            //     </Typography>
            //     <Typography variant="h6" color="primary.darker" sx={{ mb: 3 }}>
            //         Thank you for joining us as a partner.
            //     </Typography>
            //     <Button
            //         variant="contained"
            //         color="primary"
            //         size="large"
            //         onClick={() => handleClose()}
            //     >
            //         Close
            //     </Button>
            // </Box>
            <Confirmation />
        );
    }

    return (
        <>
            <Grid container xs={12} direction="row" justifyContent="flex-end" sx={{ width: '100%', paddingTop: 1, paddingBottom: 2 }} >
                <Grid item xs={12}>
                    <Typography variant="h4" color="primary.darker">'Business Associate' Review</Typography>
                </Grid>
            </Grid>

            {/* Scrollable content starts here */}
            {mlmUserObj ? <>
                <Box sx={{ maxHeight: '70vh', overflowY: 'auto', pr: 1 }}>
                    <Grid container xs={12} direction="row" justifyContent="space-between" sx={{ width: '100%', paddingLeft: 1 }} >
                        <Grid item xs={12} lg={4} >

                            <Grid container direction="row" sx={{ width: '100%' }} justifyContent="center">
                                <Grid item lg={12} xs={12} md={4} key={selectedPkgObj.id} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            //border: '.5px solid #1976d2',
                                            backgroundColor: 'primary.50',
                                            flex: 1,
                                            position: 'relative'
                                        }}
                                    >
                                        <CardContent sx={{ p: 1, "&:last-child": { pb: 1 }, position: 'relative' }}>
                                            <Grid container direction="row" justifyContent="flex-end" >
                                                <Grid item xs={6}>
                                                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                        <img
                                                            src={selectedPkgObj.imagepath}
                                                            alt={selectedPkgObj.title}
                                                            style={{ maxWidth: '100%', maxHeight: 220, objectFit: 'contain' }}
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} sx={{ borderRadius: 2, justifyContent: 'flex-end', pl: 1 }}>
                                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                        {selectedPkgObj.title}
                                                    </Typography>
                                                    <Typography variant="h5" color="primary.darker" >
                                                        {convertToRS(selectedPkgObj.price)}
                                                    </Typography>
                                                    {!apiInProgress && (<Box sx={{ justifyContent: 'flex-end', display: 'flex', alignItems: 'flex-end' }}>
                                                        <Box
                                                            sx={{
                                                                top: 12,
                                                                right: 12,
                                                                width: 36,
                                                                height: 36,
                                                                bgcolor: 'primary.100',
                                                                borderRadius: '50%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                boxShadow: 1,
                                                                cursor: 'pointer',
                                                                zIndex: 1
                                                            }}
                                                            onClick={initiEditPkg}
                                                            style={{ pointerEvents: apiInProgress ? 'none' : 'auto', opacity: apiInProgress ? 0.5 : 1 }}
                                                        >
                                                            <EditIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                                                        </Box>
                                                    </Box>)}
                                                </Grid>
                                            </Grid>



                                            {/* <List dense disablePadding>
                                            {selectedPkgObj.description.map((desc, idx) => (
                                                <ListItem key={idx} disableGutters sx={{ pl: 0, display: 'flex', alignItems: 'center' }}>
                                                    <CheckCircleIcon color="success" fontSize="small" sx={{ mr: 1 }} />
                                                    <ListItemText
                                                        primary={desc}
                                                        primaryTypographyProps={{ variant: "body2", sx: { fontSize: '1rem' } }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List> */}


                                            {/* Edit button at center right for Silver Partner */}



                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={3} >

                            {/* <Grid container direction="row" justifyContent="flex-start" sx={{ width: '100%', paddingTop: { xs: 1, lg: 0 } }}>
                                <Grid item xs={12} lg={12} md={4}>
                                    <Card sx={{ backgroundColor: 'secondary.50', mb: 1 }}>
                                        <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                                            <>
                                                <Avatar
                                                    alt={inviteeObj.title}
                                                    src={inviteeObj.avatarUrl || ''}
                                                    sx={{ width: 48, height: 48, mr: 2, bgcolor: 'primary.main', fontWeight: 600, fontSize: 22 }}
                                                >
                                                    {inviteeObj.title ? inviteeObj.title.charAt(0) : ''}
                                                </Avatar>
                                                <Box>

                                                    <Typography variant="h5" color="primary.darker" sx={{ fontWeight: 600 }}>
                                                        Invitee Associate
                                                    </Typography>
                                                    <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '1rem' }}>
                                                        {inviteeObj.seniorpartnerid === undefined ? 'Self' : inviteeObj.title}
                                                    </Typography>
                                                </Box>
                                            </>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid> */}

                            <Grid container direction="row" justifyContent="flex-start" sx={{ width: '100%', pb:2, paddingTop: { xs: 2, lg: 0 } }}>
                                <Grid item xs={12} lg={12} md={4}>
                                    <Typography variant="h5" sx={{color:'primary.darker'}}>Delivery Address </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', padding: 1, borderRadius: 2, width: '100%' }}>
                                        
                                        <Typography variant="body2" sx={{ flex: 1 }}>
                                            {getAddress()}
                                        </Typography>
                                        <IconButton size="small" aria-label="Delivery Address" onClick={handleEditAddress} disabled={apiInProgress}>
                                            <EditIcon />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} lg={4} >

                            <Grid container direction="column" justifyContent="flex-end" alignItems="stretch" sx={{ width: '100%', }}>
                                <Grid item xs={12} lg={6} sx={{ display: 'flex', alignItems: 'stretch', mb: 1, mt: 1 }}>
                                    {apiInProgress ?
                                        <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Grid> :
                                        <Card sx={{ backgroundColor: 'primary.50', padding: 1, width: '100%', height: '100%' }}>
                                            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                                                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                                    <Grid item xs={6}>
                                                        <Typography variant="h5" color="primary.darker" sx={{ fontWeight: 600 }}>
                                                            Amount to Pay
                                                        </Typography>

                                                        <Typography variant="h4" color="success.main" sx={{ fontWeight: 700 }}>
                                                            INR {mlmUserObj ? convertToRS(mlmUserObj.paymentamount) : convertToRS(selectedPkgObj.price)}/-
                                                        </Typography>
                                                        <Typography variant="body2" color="secondary.main" sx={{ fontWeight: 600 }}>
                                                            20% Discount(Special Launch Offer)
                                                        </Typography>
                                                    </Grid>
                                                    {/* {mlmUserObj.paymentamount == 0 ?
                                                        <>
                                                            <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                                                <Button variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handlePayment()}
                                                                    size="large"
                                                                // disabled={!!couponCode.trim()} // Disable when couponCode is not empty
                                                                >
                                                                    Confirm Association
                                                                </Button>
                                                            </Grid>
                                                            <Grid item xs={12} lg={12} sx={{ textAlign: 'left', paddingTop: 1 }}>
                                                                <Typography variant="caption" color="secondary">Click on 'Confirm Association' button to enjoy free Association</Typography>
                                                            </Grid>
                                                        </>

                                                        :
                                                        <> */}
                                                            <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                                                {apiInProgress ? (
                                                                    <CircularProgress size={32} />
                                                                ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={() => handlePayment()}
                                                                        size="large"
                                                                        disabled={apiInProgress} // Disable when couponCode is not empty
                                                                    >
                                                                        Pay
                                                                    </Button>
                                                                )}
                                                            </Grid>

                                                        {/* </>


                                                    } */}
                                                    {paymentError && (
                                                        <Grid item xs={12} >
                                                            <Typography variant="body1" color="error" sx={{}}>
                                                                {paymentError}
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                </Grid>

                                                {/* {mlmUserObj && !mlmUserObj.couponcode ? (
                                                    <>
                                                        <Typography variant="h6" color="secondary.dark" sx={{ fontWeight: 600, mb: 0, mt: 2 }}>
                                                            Apply Coupon
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            placeholder="Enter coupon code"
                                                            value={couponCode}
                                                            onChange={(e) => {
                                                                setCouponCode(e.target.value);
                                                                setCouponError(''); // clear error when user types
                                                            }}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <LocalOfferIcon color="secondary" />
                                                                    </InputAdornment>
                                                                ),
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            edge="end"
                                                                            color="primary"
                                                                            sx={{ mr: 1 }}
                                                                            onClick={() => handleApplyCoupon(couponCode)}
                                                                            disabled={!couponCode.trim()}
                                                                        >
                                                                            Apply
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                            sx={{ width: '100%' }}
                                                        />
                                                        {couponError && (
                                                            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                                                {couponError}
                                                            </Typography>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, border: '1px solid #ccc', borderRadius: 1, p: 1, width: '100%' }}>
                                                        <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                                            <Grid item xs={12}>
                                                                <Typography variant="h5" color="primary.darker" sx={{ fontWeight: 600 }}>
                                                                    Applied Coupon
                                                                </Typography>
                                                                <Typography variant="h5" color="primary.dark" sx={{ fontWeight: 700 }}>
                                                                    {mlmUserObj.couponcode}
                                                                </Typography>
                                                                <Typography variant="h5" color="primary.darker" sx={{ fontWeight: 600 }}>
                                                                    Discount
                                                                </Typography>
                                                                <Typography variant="h6" color="primary.dark" sx={{ fontWeight: 700 }}>
                                                                    {convertToRS(selectedPkgObj.price - mlmUserObj.paymentamount)}

                                                                </Typography>
                                                            </Grid>

                                                        </Grid>
                                                        <Button
                                                            size="small"
                                                            color="secondary"
                                                            variant="outlined"
                                                            onClick={() => {
                                                                setCouponError('');
                                                                handleRemoveCoupon();
                                                                // Optionally, you may want to call an API to remove the coupon effect from backend
                                                            }}
                                                            sx={{ ml: 1, textTransform: 'none' }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Box>
                                                )} */}
                                            </CardContent>
                                        </Card>}
                                </Grid>
                            </Grid>

                            {/* <Grid container justifyContent="flex-end" sx={{ mt: 1,  }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                        >
                                            Make Payment
                                        </Button>
                                    </Grid> */}
                        </Grid>
                    </Grid>
                </Box>
            </>
                : <Grid container xs={12} direction="row" justifyContent="center" sx={{ width: '100%' }}>
                    <Grid item xs={12} sx={{ textAlign: 'center', padding: 2 }}>
                        <CircularProgress />
                    </Grid>
                </Grid>}

            {/* Address Edit Dialog */}
            <Dialog open={addressDialogOpen} onClose={() => setAddressDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Delivery Address</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Address"
                        name="address"
                        value={addressForm.address}
                        onChange={handleAddressChange}
                        fullWidth
                        required
                    />
                    <TextField
                        margin="dense"
                        label="City"
                        name="city"
                        value={addressForm.city}
                        onChange={handleAddressChange}
                        fullWidth
                        required
                    />
                    <TextField
                        margin="dense"
                        label="Pincode"
                        name="pincode"
                        value={addressForm.pincode}
                        onChange={handleAddressChange}
                        fullWidth
                        required
                    />
                    {addressError && (
                        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                            {addressError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAddressDialogOpen(false)} color="secondary" disabled={addressApiInProgress}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSaveAddress}
                        variant="contained"
                        color="primary"
                        disabled={addressApiInProgress}
                    >
                        {addressApiInProgress ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}